import axios from "axios";
import Cookies from "js-cookie";

function attachToken(config) {
  const token = Cookies.get("userToken");

  if (token) {
    config.headers = config.headers || {};

    if (!config.headers.Authorization) {
      config.headers.Authorization = token;
    }
  }

  return config;
}

axios.interceptors.request.use(
  (config) => attachToken(config),
  (error) => Promise.reject(error)
);

const axiosInstance = axios.create({
  timeout: 15000,
});

axiosInstance.interceptors.request.use(
  (config) => attachToken(config),
  (error) => Promise.reject(error)
);

export { axiosInstance };
export default axios;
